import * as React from 'react';

import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
    Flex,
    Heading
} from '@chakra-ui/react';
import { PageContainer } from '../../components/container';

const Answers = [
    {
        question: 'Why have I received this text or e-mail?',
        answer: 'We have sent you the link to this online booking form as you have recently called Able Group and been given a quote for potential work. This online booking portal allows you to easily book in an appointment if you wish to accept and go ahead with the quoted works.',
    },
    {
        question: 'What does Additional Services/Visits mean?',
        answer: `These are products and services that can sometimes be required in addition to, or instead of the initial quoted works.
        For example: a standard treatment for Mice/Rats consists of two visits. In the case of severe infestation, we may recommend that additional chargeable visits are required to eradicate the problem.
        In the case of locksmith work we may quote for several different options as we will not know what the exact problem is with the door/window until we assess the work onsite.`,
    },
    {
        question: `What does subject to site survey mean?`,
        answer: `As you have been quoted over the phone, we are unable to guarantee that the price you have been given will stay the same. Once the engineer is on site, an assessment of the work will be carried out and the quoted price either confirmed or a new price will be given to you. You will always be notified by the engineer on site if the price is going to change before carrying out the work, and you have the right to accept or refuse the new price.`,
    },
    {
        question: `Why can I only use online booking if I am the billpayer and on site?`,
        answer: `This is to ensure that work is only booked in with the permission of the person responsible for paying for the quoted work. All other customer types can call the office on 0330 042 4256 to book a job in.`,
    },
    {
        question: `How can I book for dates other than those listed?`,
        answer: `If you wish to book for a date other than those listed, then please call the office on 0330 042 4256. This is so our team can check availability for the date you require and ensure that we have an engineer available to meet your needs.`,
    },
    {
        question: `Why do I need to provide card details?`,
        answer: `Card details are the preferred method for reserving an appointment to minimise contact during the Covid-19 pandemic. This is also to ensure that work is only booked in by the person responsible for paying for the work. No payments are taken until the work has been carried out.
        If you want to reserve your appointment using a different payment method, then please call the office on 0330 042 4256.`,
    },
    {
        question: `How are my card details stored/kept secure?`,
        answer: `Your details are encrypted on our system using industry-standard methods. Payments are processed using Square and comply with Level 1 PCI Data Security Standards.`,
    },
    {
        question: `How do I cancel or change my booking?`,
        answer: `Once a job is booked in you will be given a job reference number on the final confirmation screen. If you wish to cancel or make any changes to the job, then please call 0330 042 4256 and a member of the customer service team will be happy to help.`,
    },
]
export default function FAQSView() {
    return (<>
        <PageContainer pageTitle={'Frequently Asked Questions'}>
            <Flex align='center' w='full' direction='column'>
                <Heading color='var(--Able-blue)' size='lg' mt={4}>Frequently Asked Questions</Heading>

                <Flex direction='column' w={{base: 'full', lg: '80%'}} mt={8}>
                    <Accordion allowToggle allowMultiple>
                        {Answers.map(answer => (
                            <AccordionItem key={answer.question}>
                                <AccordionButton _expanded={{color: 'var(--Able-blue)', fontWeight: 'semibold'}}>
                                    <Box flex='1' textAlign='left'>
                                        {answer.question}
                                    </Box>
                                    <AccordionIcon />

                                </AccordionButton>
                                <AccordionPanel pb={4} pl={8} pr={8}>
                                    {answer.answer}
                                </AccordionPanel>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Flex>
            </Flex>
        </PageContainer>
    </>)
}